import { render, staticRenderFns } from "./GalleryWithText.vue?vue&type=template&id=be3b2f8a&scoped=true&"
import script from "./GalleryWithText.vue?vue&type=script&lang=js&"
export * from "./GalleryWithText.vue?vue&type=script&lang=js&"
import style0 from "./GalleryWithText.vue?vue&type=style&index=0&id=be3b2f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3b2f8a",
  null
  
)

export default component.exports